/**
 * Responsável pela funcionalidade de atribuir
 * um pedido pendente a uma rota.
 * @author: adalto.junior
 * Date: 26/11/13
 * Time: 16:21
 */



Greenmile.Views = Greenmile.Views || {};

Greenmile.Views.EventNotification = Greenmile.Views.EventNotification || {};

Greenmile.Views.EventNotification.CancelEvent = (function () {

    function CancelEvent () {

        Monet.GenericModal.apply(this, arguments);

        var __eventId = null;
        var __event = null;
        var __selector = null;
        var __callback = null;

        this.setEventId = function (eventId) {

            __eventId = eventId;

        };

        this.setEvent = function (event) {

            __event = event;

        };

        this.setSelector = function (selector) {

            __selector = selector;

        };

        this.setCallback = function (callback) {

            if (callback) {
                __callback = callback;
            }

        };

        this.getCallback = function () {

            if (__callback) {
                __callback.execute();
            }

        };

        var renderEventInformation = function (scope) {

            var renderedHTML = Greenmile.Templates.formCloseEvent({ _id: __eventId });
            var currentTab = Monet.Utils.GetTabName();

            currentTab = (currentTab === 'TrackEquipmentMapsDisplay')
                         ? 'TrackEquipmentMaps'
                         : currentTab;

            $("#" + currentTab + " .popupFormContainer").html(renderedHTML);

            Monet.I18n.translateInterface();

            $(".btnHideCloseEvent_" + __eventId).on("click", scope.closeModalWindow);

            $(".btnCloseEvent_" + __eventId).on("click", function () {

                var objEvent = App.Objects.EventNotifications;

                scope.modalForm.toggleLoadingInModalBtn();

                objEvent.closeEvent(__eventId, this);
                __event.closed = true;
                var popup = document.querySelector('.leaflet-popup-close-button');
                if (popup) {
                    popup.click();
                }
                scope.getCallback();

            });
        };


        this.createForm = function () {

            renderEventInformation(this);

        };

        this.afterCloseModalForm = function () {
            if(App.Forms?.RouteTracker?.cannotUpdate)
                App.Forms.RouteTracker.cannotUpdate = false;
        };

        this.createAllStructure = function (context) {

            return function () {
                context.createForm();
            };

        }(this);

    };

    return CancelEvent;

}());
